import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  DKInputForm,
  showToast,
  TOAST_TYPE,
  showLoader,
  removeLoader,
  isEmpty,
  DKSpinner,
  DKIcons,
  showAlert,
  DKIcon,
  DKLabel,
  DKButton
} from "deskera-ui-library";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import DataGridUtility from "../../utility/DataGridUtility";
import Popup from "../common/Popup";
import Table from "../../services/table";
import { DealManager } from "../../managers/DealManager";
import {
  commonCustomEvent,
  COMMON_EVENTS,
} from "../../services/event/commonEvents";
import { showAddColumnPopup } from "../common/AddColumnPopup";
import TenantManager from "../../managers/TenantManager";
import { CANDIDATE_ACCEPT_FILE_TYPE, CONSTANTS, INPUT_TYPE, VALID_FIELD_MAX_LENGTH } from "../../constants/Constant";
import ContactManager from "../../managers/ContactManager";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import Utility,{ deepClone, getRandomHexString, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { StateManager } from "../../managers/StateManager";
import AttendanceService, { defaultTeamConfig } from "../../services/AttendanceService";
import { fetchTeamAttendance } from "../../Redux/Slices/TeamAttendanceSlice";
import UserService from "../../services/UserService";
import CustomFormField from "./CustomFormField";
import i18next from "i18next";
import ApiConstants from "../../constants/ApiConstants";
import { renderFileHtml } from "../../managers/common/CommonUtil";

const uploadCloudImg = "http://s3.ap-southeast-1.amazonaws.com/cdn-crm-common-env/report/thumbnail/71273/1628178064451_upload_cloud_outlined.svg";
export interface IAddNewRecordPopUpProps {
  tableName: string;
  recordId?: string;
  id: string;
  onSave?: (data: any) => void;
  onClose?: () => void;
  defaultValues: any;
  displayName: string;
  isCustomForm: boolean;
  inputData: any;
  popupClass: string;
  candidateToFilter: any;
}
export interface IAddNewRecordPopUpState {
  formFields: any[];
}
class AddNewRecordPopUp extends Component<
  IAddNewRecordPopUpProps,
  IAddNewRecordPopUpState
> {
  columns = [];
  isUpdated: boolean = false;
  isCustomFieldAdded = false;
  columnBeforeCustomFieldAdd = [];
  defaultValues:any[] = [];
  defaultValuesBeforeCustomField;
  constructor(props) {
    super(props);
    this.state = {
      formFields: [],
    };
    this.defaultValues = Object.assign({}, this.props.defaultValues); 
    this.isUpdated = !isEmpty(this.props.recordId);
  }
  componentDidMount() {
    this.buildForm();
  }
  buildForm = () => {
    this.columns = [];
    console.log(JSON.parse(JSON.stringify(TableManger.getTableColumns(this.props.tableName))))
    this.columns = JSON.parse(JSON.stringify(TableManger.getTableColumns(this.props.tableName).filter(
      (obj:any) => (obj.editable || obj.type === 'file') && obj.uiVisible
    )))
    this.putAdditionalFields().then(() => {
      let formFields = DataGridUtility.getFormElements(
        this.columns,
        this.defaultValues
      );
      this.setState({
        formFields,
      });
    });
  }
  removePopUp = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.props.id));
    document.getElementById(this.props.id)?.remove();
  }
  onClose = () => {
    if (this.props.onClose) this.props.onClose();
    this.removePopUp();
    if(this.props.onSave) {
      this.props.onSave({})
    }
  };
  onSave = (data) => {
    const tableId = TableManger.getTableId(this.props.tableName);
    const dataToSend = { ...this.defaultValues, ...data };
    showLoader(`Record is being ${this.isUpdated ? "updated" : "added"}...`);
    if(this.props.tableName === TABLES.JOB_PIPELINE) {
      this.addPipeline(data);
    } else if (this.props.tableName === TABLES.CANDIDATE && this.props.isCustomForm) {
      this.addCandidateToPipeline(data)
    } else if (this.props.tableName === TABLES.CANDIDATE ) {
      
      const cleanData = Object.entries(dataToSend)
        .filter(([key, value]) => value !== undefined)
        .reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, {});
      this.addCandidate(cleanData)
    } else if (this.props.tableName === TABLES.TEAM_ATTENDANCE ) {
      this.filterAttendance(data)
    } else {
      
      (!this.isUpdated
        ? Table.addRecord({ cells: dataToSend }, tableId)
        : Table.updateRecord(dataToSend, this.props.recordId, tableId)
      )
        .finally(() => removeLoader())
        .then(
          (res) => {
            showToast(
              `${this.isUpdated ? "Updated" : "Added"} Record Successfully`,
              TOAST_TYPE.SUCCESS
            );
            if (this.props.onSave) this.props.onSave(dataToSend);
            document.dispatchEvent(new CustomEvent(COMMON_EVENTS.ADD_NEW_REC, {
              detail: {
                tableName: this.props.tableName,
                data: dataToSend,
                refresh: this.isUpdated ? true : false
              } }))
            this.removePopUp();
          },
          (err) => {
            showToast(
              "Some Unknown Error Occurred at Server.Please Try Again!",
              TOAST_TYPE.FAILURE
            );
          }
        );
    }
  };
  filterAttendance=(data)=>{
    let config = AttendanceService.apiTeamConfig;
    config.filter = (data['designation'])? data['designation'].join():'';
    if (data?.shift?.length > 0) {
        config.shift = data.shift.join(",");
        if (config.query.includes("shift_id=!")) {
            const index = config.query.indexOf("shift_id=!");
            config.query = config.query.substring(0, index - 1);
        }
        config.query = `${config.query},shift_id=!${data.shift.join(",")}`;
    } else {
        config.shift = "";
        if (config.query.includes("shift_id=!")) {
            const index = config.query.indexOf("shift_id=!");
            config.query = config.query.substring(0, index - 1);
        }
    }
    config.page = '0';
    this.loadAttendance(config);
  }
  loadAttendance = async (config) => {
    try {
      const timeout = showDelayedLoader();
      AttendanceService.apiTeamConfig = config;
      await this.props.inputData.dispatch(fetchTeamAttendance());
      this.removePopUp();
      removeLoader();
      removeDelayedLoader(timeout);
    } catch (err) {
      console.error("Error loading contacts: ", err);
    }
};
  onChange = (allFields, changedData) => {
    allFields.forEach(field => {
      this.defaultValues[field.id] = field.value;
    });
  }
  
  render() {
    return (
      <Popup popupClass={this.props.popupClass}>
        {this.state.formFields.length !== 0 && (
          <>
            {!this.props.isCustomForm && <DKInputForm
              title={`${this.isUpdated ? "Edit" : "Add"} ${this.props.displayName}`}
              fields={this.state.formFields.filter(field=>field.type !== 'file')}
              onCancel={() => this.onClose()}
              onChange={this.onChange}
              onSubmit={(data) => {
                this.onSave(DataGridUtility.getRowData(data, this.columns));
              }}
            />}
            {this.props.isCustomForm && <CustomFormField
        title={`${this.isUpdated ? "Edit" : "Add"} ${this.props.displayName}`}
        fields={this.state.formFields}
        onCancel={() => this.onClose()}
        onChange={this.onChange}
        onSubmit={(data) => {
          this.onSave(DataGridUtility.getRowData(data, this.columns));
        }}
      />}
            {/* {console.log(this.state,this.props)} */}
            {(this.props.tableName == 'candidate' && !this.props.isCustomForm) && this.getFileUpload()}
            {this.props.tableName != TABLES.DEAL && !this.props.isCustomForm &&
            <div className="row row-reverse mt-l">
              <DKButton
                className="bg-gray1 border-m"
                title={"New Field"}
                icon={DKIcons.ic_add}
                onClick={this.addCustomField}
              />
            </div>
            }
          </>
        )}
        {this.state.formFields.length === 0 && (
          <div
            className="row justify-content-center"
            style={{ minHeight: 100 }}
          >
            <DKSpinner title="Loading form fields..." />
          </div>
        )}
      </Popup>
    );
  }

  addCustomField = () => {
    this.columnBeforeCustomFieldAdd = this.columns
    this.defaultValuesBeforeCustomField = this.defaultValues;
    this.onCustomFieldAdd()
  }

  putAdditionalFields = () => {
    switch (this.props.tableName) {
      case TABLES.DEAL:
        return this.addPipelineAndStage();
      case TABLES.TEAM_ATTENDANCE:
         this.addTeamFilter();
         return Promise.resolve();
      case TABLES.CANDIDATE:
        if( this.props.isCustomForm){
          this.addContactColumn();
        } else {
          this.updateSegmentOptions();
        }
        return Promise.resolve();
      default:
        return Promise.resolve();
    }
  };
  addPipelineAndStage = () => {
    let pipelines = [];
    let contacts = [];
    const pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    const stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    return Table.getRecordsByPage(null, null, pipelineTableId).then(
      (records: any) => {
        pipelines = DealManager.parsePipelineData(records);
        return Table.getRecordsByPage(null, null, stageTableId).then(
          (res: any) => {
            DealManager.putStagesInPipeline(pipelines, res);
            return Table.getRecordsByPage(
              null,
              DealManager.getQuery("personQuery"),
              TableManger.getTableId(TABLES.CANDIDATE)
            ).then((contact) => {
              contacts = DealManager.contactData(contact.data);
              const pipelineColumn = TableManger.getColumn(
                TABLES.DEAL,
                COLUMN_CODE.DEAL.PIPELINE_ID
              );
              const stageColumn = TableManger.getColumn(
                TABLES.DEAL,
                COLUMN_CODE.DEAL.STAGE_ID
              );
              const contactColumn = TableManger.getColumn(
                TABLES.DEAL,
                COLUMN_CODE.DEAL.CONTACT_ID
              );
              this.columns.forEach(column => {
                if (column.columnCode === 'amount') {
                  column.name = `${column.name} (${TenantManager.getCurrency()})`
                }
              })

              if (pipelines) {
              this.columns.push({
                id: contactColumn.id,
                key: contactColumn.id,
                columnCode: contactColumn.columnCode,
                name: "Candidate",
                required: false,
                type: "Select",
                value: contacts[this.defaultValues[contactColumn.id]] ? [0] : [],
                options: contacts,
              });
              this.columns.push({
                id: pipelineColumn.id,
                key: pipelineColumn.id,
                columnCode: pipelineColumn.columnCode,
                name: "Pipeline",
                required: true,
                type: "Select",
                value: [0],
                options: pipelines,
              });
              this.columns.push({
                id: stageColumn.id,
                key: stageColumn.id,
                columnCode: stageColumn.columnCode,
                name: "Stage",
                required: true,
                type: "Select",
                value: [0],
                options:
                  pipelines[this.defaultValues[pipelineColumn.id][0]]
                    .stages,
              });
            }
              return Promise.resolve();
            });
          }
        );
      }
    );
  };

  onCustomFieldAdded = () => {
    this.isCustomFieldAdded = true
    this.buildForm()
    this.isCustomFieldAdded = false
  }

  onCustomFieldAdd = () => {
    showAddColumnPopup({ tableName: this.props.tableName }, () => {
      this.onCustomFieldAdded();
    });
  }
  addPipeline(pipelineData) {
    const pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    const stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.NAME
    );
    const stageWonColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.WON_STAGE
    );
    const stageLostColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.LOST_STAGE
    );
    const stageHelpTextColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.HELP_TEXT
    );
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    const stageOrderColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.ORDER
    );
    let defaultStagesForNewPipeline = [];
    defaultStagesForNewPipeline.push({
      cells: {
        [stageNameColumnId]: "New Stage",
        [stageWonColumnId]: false,
        [stageLostColumnId]: false,
        [stageHelpTextColumnId]: "New Stage",
        [stageOrderColumnId]: 0,
      },
    });
    showLoader("Adding Pipeline...");
    Table.addBulkRecord(defaultStagesForNewPipeline, stageTableId).then(
      (response) => {
        let ids = [];
        response.data.forEach((stage) => {
          ids.push(stage._id);
        });
        pipelineData[stageIdsColumnId]=ids;
        Table.addRecord({ cells: pipelineData }, pipelineTableId)
          .finally(() => removeLoader())
          .then((data) => {
            showToast("Pipeline Added Successfully.", TOAST_TYPE.SUCCESS);
            if (this.props.onSave) this.props.onSave(pipelineData);
            document.dispatchEvent(new CustomEvent(COMMON_EVENTS.ADD_NEW_REC, { detail: { tableName: this.props.tableName } }))
            this.removePopUp();
            removeLoader();
          },
            (err) => {
              removeLoader();
              showToast(
                "Some Unknown Error Occurred at Server.Please Try Again!",
                TOAST_TYPE.FAILURE
              );
            });
      }
    );
  }
  addContactColumn() {
    let candidates = [];
      candidates = DealManager.contactData(this.props.inputData);
      if(this.props.candidateToFilter) {
        candidates = candidates.filter(c=>this.props.candidateToFilter.findIndex(cf=>cf.id==c.id) === -1)
      }
      const jobOpeningColumn = TableManger.getColumn(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOBOPENING
      );
      this.columns = this.columns.filter(x => x.id == jobOpeningColumn.id);
      this.columns.forEach(element => {
        if (element.id === jobOpeningColumn.id) {
          element.name = "Candidate";
          element.options = candidates;
          element.type = INPUT_TYPE.DROPDOWN
          element.multiSelect = true;
          element.required = true;
        }
      });
  }
    addTeamFilter() {
        const designations = this.props.inputData.designations?.designations || [];
        const shifts = this.props.inputData.shifts || [];

        const designationColId = TableManger.getColumn(TABLES.TEAM_ATTENDANCE, COLUMN_CODE.ATTENDANCE_TEAM.DESIGNATION);
        const shiftColId = TableManger.getColumn(TABLES.TEAM_ATTENDANCE, COLUMN_CODE.ATTENDANCE_TEAM.SHIFT);
        this.columns = this.columns.filter(x => x.id == designationColId.id || x.id == shiftColId.id);
        if(this.props.defaultValues.status) {
          this.columns.push({
            columnCode: "status",
            editable: true,
            hidden: false,
            id: "status",
            index: 2,
            key: "status",
            name: "Status",
            options: [{id:'all',name:"All"},{id:"present",name:"Present"},{id:"absent",name:"Absent"}],
            required: false,
            systemField: true,
            type: INPUT_TYPE.SELECT,
            uiVisible: true,
            width: 200
          })
        }
        this.columns.forEach((column) => {
            switch (column.id) {
                case designationColId.id:
                    column.type = INPUT_TYPE.MULTI_SELECT;
                    column.name = "Job Title";
                    column.options = designations.map((designation) => {
                        return {
                            id: designation,
                            name: designation
                        }
                    });
                    break;
                case shiftColId.id:
                    column.tooltip = { content: "Allowed to filter only on shifts with selected users", className: "warning-tooltip-prop" };
                    column.type = INPUT_TYPE.MULTI_SELECT;
                    column.options = shifts.map((shift) => {
                        return {
                            id: shift.id,
                            name: shift.name
                        }
                    });
                    break;
                default:
                    break;
            }
        });
    }

  addCandidateToPipeline(data) {
    let recordsToUpdate = [];
    let candidateTableId = TableManger.getTableId(TABLES.CANDIDATE);
    let candidateColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
    let candidateJobPipelineColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
    let candidateJobStageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
    let candidatesIds = data[candidateColumnId];
    candidatesIds.forEach(id => {
      let candidateRecord = {
        "_id": id,
        "cells": {
          [candidateJobPipelineColumnId]: this.defaultValues[candidateJobPipelineColumnId],
          [candidateJobStageColumnId]: this.defaultValues[candidateJobStageColumnId]
        }
      }
      recordsToUpdate.push(candidateRecord);
    });
    Table.updateBulkRecord(recordsToUpdate, candidateTableId)
      .finally(() => removeLoader())
      .then((data) => {
        showToast("Pipeline assigned Successfully.", TOAST_TYPE.SUCCESS);
        if (this.props.onSave) this.props.onSave(recordsToUpdate);
        document.dispatchEvent(new CustomEvent(COMMON_EVENTS.ADD_NEW_REC, { detail: { tableName: this.props.tableName } }))
        this.removePopUp();
        removeLoader();
      },
        (err) => {
          removeLoader();
          showToast(
            "Some Unknown Error Occurred at Server.Please Try Again!",
            TOAST_TYPE.FAILURE
          );
        });
  }
  updateSegmentOptions() {
    let pipelineData = this.props.inputData || [];
    let segment = TableManger.getColumn(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)
    let segmentData = segment.options || [];
    // segmentData = this.prepareDataForSegments(segmentData, CONSTANTS.SEGMENT);
    // pipelineData = this.prepareDataForSegments(pipelineData, CONSTANTS.PIPELINE);
    const jobOpeningColumn = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    const emailColumn = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.EMAIL
    );
    
    this.columns.forEach(element => {
      if (element.id === emailColumn) {
        element.required = true 
      }

      if (element.id === jobOpeningColumn) {
        element.required = true;
        element.options = segmentData
      }
    });
    if(this.isUpdated) {
      let pipeLineColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
      let jobOpenings = this.defaultValues[jobOpeningColumn] ? this.defaultValues[jobOpeningColumn] : [];
      let pipelines = this.defaultValues[pipeLineColumnId] ? this.defaultValues[pipeLineColumnId] : [];
      if(this.isCustomFieldAdded) {
        this.columns.forEach(column=>{
          if(column.id === jobOpeningColumn) {
            jobOpenings = jobOpenings?.filter(job=> column.options.filter(c=>c.id == job))
            this.defaultValues[jobOpeningColumn] = jobOpenings
          }
        })
        this.columnBeforeCustomFieldAdd.push(this.columns[this.columns.length-1])
        this.columns = this.columnBeforeCustomFieldAdd
        this.defaultValues = this.defaultValuesBeforeCustomField; 
        
      } else {
        this.columns.forEach(column=>{
          if(column.id === jobOpeningColumn) {
            jobOpenings = jobOpenings?.filter(job=> column.options.some(c=>c.id == job))
            this.defaultValues[jobOpeningColumn] = jobOpenings
          }
        })
        ContactManager.getDataToUpdateForCandidate(this.defaultValues, this.columns);
      }
      
    } else {
      if(this.isCustomFieldAdded && this.columnBeforeCustomFieldAdd.length != 0) {
        let jobOpenings = this.defaultValues[jobOpeningColumn] ? this.defaultValues[jobOpeningColumn] : [];
        this.columns.forEach(column=>{
          if(column.id === jobOpeningColumn) {
            jobOpenings = jobOpenings?.filter(job=> column.options.filter(c=>c.id == job))
            this.defaultValues[jobOpeningColumn] = jobOpenings
          }
        })
        this.columnBeforeCustomFieldAdd.push(this.columns[this.columns.length-1])
        this.columns = this.columnBeforeCustomFieldAdd
        this.defaultValues = this.defaultValuesBeforeCustomField; 
      }
    }
  }
  prepareDataForSegments(data, module) {
    data.forEach(element => {
      switch (module) {
        case CONSTANTS.SEGMENT:
          element["type"] = module;
          break;
        case CONSTANTS.PIPELINE:
          if (element.name === CONSTANTS.DEFAULT_JOB_PIPELINE) {
            element.name = CONSTANTS.DEFAULT_PIPELINE
          }
          element["type"] = module;
      }
    });
    return data;
  }
  showWarningForJobOpening =(dataToSend)=>{
    showAlert('Alert',i18next.t('JOB_OPENING_ALERT'),[
      {
          title: "Continue",
          className: "bg-app text-white mr-r",
          onClick: () => this.addCandidate(dataToSend,true),
      },
      {
          title: "Cancel",
          className: "bg-gray1 border-m"
      }
  ]);
  }
  addCandidate(dataToSend, isContinue=false) {
    const dataToSendCopy = deepClone(dataToSend)
    const contactId = getRandomHexString();
    const tableId = TableManger.getTableId(this.props.tableName);
    const segmentObject = this.getSegmentAndPipelineData(dataToSend);
    if(segmentObject.segments && segmentObject.segments.length === 0 && !isContinue) {
       this.showWarningForJobOpening(dataToSendCopy);
        removeLoader();
      return
    }
    if(this.checkDataInvalid(dataToSend, this.props.tableName)) {
      removeLoader();
      return;
    }
    this.getStatusAndStageData(dataToSend);
    if(!this.isUpdated) {
      StateManager.get(this.props.tableName).then((data) => {
        let contactData = data;
        contactData.data = [{ _id: contactId, cells: dataToSend }, ...data.data];
        StateManager.set(TABLES.CANDIDATE, contactData);
        document.dispatchEvent(
          new CustomEvent(COMMON_EVENTS.ADD_NEW_REC, {
            detail: {
              data: dataToSend,
              table: this.props.tableName,
              refresh: this.isUpdated ? true : false,
            },
          })
        );
      });
    }
    // showLoader(`Record is being ${this.isUpdated ? "updated" : "added"}...`);
    (!this.isUpdated
      ? Table.addRecord({ _id: contactId, cells: dataToSend }, tableId)
      : Table.updateRecord(dataToSend, this.props.recordId, tableId)
    )
      // .finally(() => removeLoader())
      .then(
        (res) => {
          showToast(
            `${this.isUpdated ? "Updated" : "Added"} Record Successfully`,
            TOAST_TYPE.SUCCESS
          );
          if (this.props.onSave) this.props.onSave(dataToSend);
          document.dispatchEvent(new CustomEvent(COMMON_EVENTS.ADD_NEW_REC, {
            detail: {
              data: dataToSend,
              tableName: this.props.tableName,
              refresh: this.isUpdated ? true : false
            }
          }))
          this.removePopUp();
          removeLoader();
        },
        (err) => {
          removeLoader();
          showToast(
            "Some Unknown Error Occurred at Server.Please Try Again!",
            TOAST_TYPE.FAILURE
          );
        }
      );

  }
  checkDataInvalid(dataToSend, tableName) {
    let isInvalid = false;
    const tableColumns = TableManger.getTableColumns(tableName);
    const filterColumns = tableColumns.filter(col=>col.type === INPUT_TYPE.EMAIL)
    filterColumns.forEach(column=>{
      if(column.id && dataToSend[column.id] && dataToSend[column.id].trim().length > VALID_FIELD_MAX_LENGTH.EMAIL) {
        isInvalid = true;
        showAlert('Please correct details',
          `<b>${column.name}</b> should not be more than <b>${VALID_FIELD_MAX_LENGTH.EMAIL}</b> characters length.`
        );
        return true
      }
    })
    return isInvalid
  }
  getSegmentAndPipelineData(data) {
    let segmentData = this.columns.filter(column => column.id == TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING));
    let totalSegments = segmentData.length > 0 ? segmentData[0].options : [];
    let selectedIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)];
    let assignedSegment = [];
    let assignedPipeline = [];
    let assignedStage = [];
    selectedIds.forEach(id => {
      let item = totalSegments.filter(x => x.id === id);
      if (item && item.length > 0) {
        let selection = item[0];
        switch (selection.type) {
          case CONSTANTS.SEGMENT:
            let isPresent = assignedSegment.some(x => selection.id === x);
            if (!isPresent) {
              assignedSegment.push(selection.id);
            }
            break;
          case CONSTANTS.PIPELINE:
            let isPresentInPipeline = assignedPipeline.some(x => selection.id === x);
            if (!isPresentInPipeline) {
              assignedPipeline.push(selection.id);
              let stageIds = selection[COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
              if (stageIds && stageIds.length > 0) {
                assignedStage.push(stageIds[0]);
              }
            }
            break;
          default:
            let isPresentinSegment = assignedSegment.some(x => selection.id === x);
            if (!isPresentinSegment && typeof selection.id === "number") {
              assignedSegment.push(selection.id);
            }
        }
      }
    });
    let jobOpeningColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
    let jobPipelineColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
    let jobStageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
    data[jobOpeningColumnId] = assignedSegment && assignedSegment.length > 0 ? assignedSegment : [1];
    data[jobPipelineColumnId] = assignedPipeline || [];
    data[jobStageColumnId] = assignedStage || [];
    return {
      segments: assignedSegment
    }
  }
  getStatusAndStageData(data) {
    let statusData = this.columns.filter(column => column.id == TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS));
    let totalStatus = statusData.length > 0 ? statusData[0].options : [];
    let selectedIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS)];
    let assignedStage = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)];
    let assignedStatus = [];
    selectedIds.forEach(id => {
      let item = totalStatus.filter(x => x.id === id);
      if (item && item.length > 0) {
        let selection = item[0];
        switch (selection.type) {
          case CONSTANTS.STATUS:
            let isPresent = assignedStatus.some(x => selection.id === x);
            if (!isPresent) {
              assignedStatus.push(selection.id);
            }
            break;
          case CONSTANTS.STAGE:
            let isPresentInStage = assignedStage.some(x => selection.id === x);
            if (!isPresentInStage) {
              let isStagePresentInPipeline = this.checkIfStageIsPresentInPipeline(data, selection.id);
              // if (isStagePresentInPipeline) {
              //   assignedStage.push(selection.id);
              // }
            }
            break;
          default:
            let isPresentinStatus = assignedStatus.some(x => selection.id === x);
            if (!isPresentinStatus && typeof selection.id === "number") {
              assignedStatus.push(selection.id);
            }
        }
      }
    });
    let statusColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
    data[statusColumnId] = assignedStatus && assignedStatus.length > 0 ? assignedStatus : [1];
  }
  checkIfStageIsPresentInPipeline(data, stageId) {
    let isValidStage = false;
    let selectedPipelineIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID)];
    const jobPipelines = JobPipelineService.getPipelineData(JobPipelineService.pipelineData);
    selectedPipelineIds.forEach(element => {
      let selectedPipeline = jobPipelines.filter(item => item.id === element);
      if (selectedPipeline && selectedPipeline.length > 0) {
        let stages = selectedPipeline[0][COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
        let isPresent = stages.some(x => x === stageId);
        if (isPresent) {
          const jobStageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
          let assignedStage = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)] || [];
          stages.forEach(stage => {
            if (assignedStage.some(x => x === stage)) {
              let index = assignedStage.indexOf(stage);
              assignedStage.splice(index, 1, stageId);
            }
            // else {
            //   data[jobStageColumnId] = assignedStage.push(stageId);
            // }
          });
          isValidStage = true;
        }
      }
    });
    return isValidStage;
  }
  getFileUpload() {
    return this.state.formFields.filter(field => field.type === 'file').map(field => {
      return this.getFileUploadField(field)
    })

  }
  getFileUploadField = (field) => {
    return (
      <>
      <DKLabel className="mb-xs mt-m" text={`${field.name}`}/>
      <div className="border-m p-m border-radius-m mb-l">
        <div
          className="cursor-hand border-radius-m"
          id={`file-upload-${field.id}`}
        >
          <img style={{ height: "60px", display: "none" }} src={uploadCloudImg} alt="Upload Cloud" />
          <div style={{
            display: 'flex',
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "left"
          }}>
            
            <div
              className="mr-m"
              style={{
                display: 'flex',
                alignItems: "center",
                justifyContent: "between",
                textAlign: "left"
              }}>
              <button id={`choose-file-button-${field.id}`} type="button" style={{
                borderRadius: '8px',
                height: '30px',
                width: '130px',
                backgroundColor: "#fff",
                fontWeight: 600,
                border: "1px solid #dcdcdc",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "5px",
                cursor: "pointer"
              }}
                onClick={() => {
                  const docElement = document.getElementById(`file-input-${field.id}`)
                  docElement?.click()
                  docElement?.addEventListener('change', (value: any) => {
                    if (value?.target?.files) {
                      let files = []
                      const docValue = this.defaultValues[field.id];
                      if (!Utility.isEmpty(docValue)) {
                        try {
                          files = Utility.decodeJSON(docValue)
                        } catch (error) {
                          console.log(error)
                        }
                      }
                      this.upload(value.target.files[0], files, field)
                    }
                  }, false)
                }}
              >
                <img src={DKIcons.ic_document} style={{ height: "16px" }} />
                <span style={{ marginLeft: "5px" }}>Choose a file</span>
              </button>
              <span style={{
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                fontSize: "13px",
                textAlign: "left"
              }}>Choose .pdf, .docx or .doc
              </span>
            </div>
          </div>
          <input
            className="d-none"
            type="file"
            name="file"
            id={`file-input-${field.id}`}
            required
            style={{
              visibility: "hidden"
            }}
            accept={CANDIDATE_ACCEPT_FILE_TYPE.join()}
          />
        </div>
        {this.getFileValues(field)}
      </div>
      </>
    )
  }
  upload(param,documentList, field) {
    
    let inputData = new FormData();
    inputData.append("file", param);
    inputData.append("file-entity", "REPORT_THUMBNAIL");
    let requestOptions:any = {
      method: "POST",
      credentials: "include",
      withCredentials: true,
      mode: "cors",
      body: inputData,
    };
    showLoader()
    let urlObject = ApiConstants.URL;
    fetch(urlObject.BASE + urlObject.IMPORT_EXPORT.UPLOAD_FILE_PUBLIC, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        if(responseData.status === 400) {
          removeLoader();
          return
        }
        if(responseData?.status === 500 && responseData?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
          showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
          removeLoader();
          return
        }
        if (responseData?.publicUrl) {
          let newAttachment = {
            title: param.name,
            type: param.type,
            path: responseData.publicUrl,
          };
          documentList.push(newAttachment);
          var attachments = documentList;
          this.defaultValues[field.id] = btoa(encodeURI(JSON.stringify(attachments)))
        }
        removeLoader();
        
        this.setState({...this.state})
      }, error => {
        console.log(error)
        showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
        removeLoader()
      })
  }
  getFileValues = (field) => {
    let files = []
    const value = this.defaultValues[field.id];
    if (!Utility.isEmpty(value)) {
      try {
        files = Utility.decodeJSON(value)
      } catch (error) {
        console.log(error)
      }
    }
    if (files.length > 0) {
      return <div id={`file-details-${field.id}`} style={{ marginTop: "30px" }}>
        <div style={{ marginTop: "-20px", float: "left" }}>File Details</div>
        <div className="bg-gray1 border-radius-m border-m">
          {this.getFileDetails(files,field)}
        </div>
      </div>
    } else {
      return <></>
    }
  }
  getFileDetails = (files,field) => {
    return files.map((file,index) => {
      return (
      <div className="d-flex justify-content-between p-m">
        <div className="d-flex cursor-hand" onClick={() => window.open(file.path, "_blank")}>
          <DKIcon className="ic-s mr-s"  src={Utility.getFileIcon(file.title)}/>
          <span className="word-break-all" id={`file-name-${file.title}`} >{file.title}</span>
        </div>
        <DKIcon className="ic-s mr-s cursor-hand"  src={DKIcons.ic_delete} onClick={()=>this.onDeleteAttachment(files,index,field)}/>
      </div>
      )
    })
  }
  onDeleteAttachment = (files,index,field) => {
    files.splice(index,1);
    this.defaultValues[field.id] = Utility.encodeJSON(files);
    this.setState({...this.state})
  }
}
export const showFormPopup = (
  config: { tableName: string; displayName: string; defaultValues?: any; recordId?: string; isCustomForm?:any; inputData?:any; popupClass?:string,candidateToFilter?:any },
  onSave: () => void,
  onClose: () => void
) => {
  const id = `add-new-rec-popup-${new Date().getTime()}`;
  let div = document.createElement("div");
  div.className = "app-font";
  div.setAttribute("id", id);
  config.popupClass = config.popupClass || "";
  ReactDOM.render(
    <AddNewRecordPopUp
      id={id}
      tableName={config.tableName}
      onSave={onSave}
      onClose={onClose}
      defaultValues={config.defaultValues}
      recordId={config.recordId}
      displayName={config.displayName}
      isCustomForm={config.isCustomForm}
      inputData={config.inputData}
      popupClass={config.popupClass}
      candidateToFilter={config.candidateToFilter}
    />,
    document.body.appendChild(div)
  );
};
export default AddNewRecordPopUp;
